import { render, staticRenderFns } from "./calculator_tax.vue?vue&type=template&id=dc60d254&scoped=true&"
import script from "./calculator_tax.vue?vue&type=script&lang=js&"
export * from "./calculator_tax.vue?vue&type=script&lang=js&"
import style0 from "./calculator_tax.vue?vue&type=style&index=0&id=dc60d254&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc60d254",
  null
  
)

export default component.exports